package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class EphemeralKeyResponse(
    @SerialName("ephemeralKey") var ephemeralKey: EphemeralKey? = null

)